import {
    Box,
    LinearProgress,
    Typography,
} from "@mui/material";
import { useGetRaffleStatusPublicQuery } from "../../store/api";
import { CircularProgressRaffle } from "../raffle/circularProgress";

interface ProgressBarProps {
    raffleId: string;
    type?: 'circle' | 'bar';
}

export const ProgressBar = ({ raffleId, type = 'circle' }: ProgressBarProps) => {
    const { data: raffleStatusFounded } = useGetRaffleStatusPublicQuery(raffleId, {
        skip: raffleId === 'default',
        refetchOnReconnect: true,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true,
    });

    const progress = raffleStatusFounded?.progress ?? 0;

    return (
        <Box width="100%">
            {type === 'circle' ? (
                <Box display="flex" justifyContent="center" alignItems="center" mb={2}>
                    <CircularProgressRaffle value={progress} size={100} />
                </Box>
            ) : (
                <Box px={2} mb={2}>
                    <Box display="flex" justifyContent="space-between" mb={0.5}>
                        <Typography variant="body2" color="textSecondary">
                            Progreso
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {progress}%
                        </Typography>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{ height: 10, borderRadius: 5 }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default ProgressBar;
